<div class="flex flex-column">
  <label for="" class="mb-1">Please select your role</label>
<p-dropdown
  [options]="roles"
  optionLabel="role_name"
  [filter]="true"
  filterBy="role_name"
  class="login"
  [showClear]="true"
  placeholder="Choose your role"
  [ngClass]="errorClass"
  (onChange)="onDropdownChange($event.value)"
  [appendTo]="'body'"
  [(ngModel)]="selectedValue"
>
</p-dropdown>
</div>
